import { Tooltip } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { MdFormatClear } from "react-icons/md";
import { twMerge } from "tailwind-merge";
import { useTextEditorContext } from "../../hooks/useTextEditorContext";
import { buttonStyleHiddenOnMobile } from "./TextEditorMenuStyle";

export interface TextEditorMenuButtonDeleteFormatProps {
  className?: string;
  children?: React.ReactNode;
}

export const TextEditorMenuButtonDeleteFormat = ({ className, children }: TextEditorMenuButtonDeleteFormatProps) => {
  const { t } = useTranslation("textEditor");
  const { editor, disabled } = useTextEditorContext();

  return (
    <Tooltip content={t("buttons.removeformat")}>
      <button
        type="button"
        onClick={() => {
          if (editor) {
            editor.chain().focus().unsetAllMarks().clearNodes().run();
          }
        }}
        className={twMerge(buttonStyleHiddenOnMobile, className)}
        disabled={disabled}
      >
        {children ?? <MdFormatClear className="h-6 w-6" />}
      </button>
    </Tooltip>
  );
};
